// extracted from @fastcampus/config#trackers
const envConfigs = {
  dev: {
    google: {
      id: 'UA-138245180-1',
      optimize: 'OPT-5DMCTZR',
    },
    facebook: {
      id: '513329212774325',
    },
  },
  staging: {
    google: {
      id: 'UA-138245180-3',
      optimize: 'OPT-MRG6GTV',
    },
    facebook: {
      id: '1272648416245898',
    },
  },
  prod: {
    google: {
      id: 'UA-58391551-1',
      conversion: 'AW-929832871',
      optimize: 'OPT-WXM7BNJ',
    },
    facebook: {
      id: '1648117745465194',
    },
    mobon: {
      id: 'fastcampus',
    },
    kakao: {
      id: '8801318905351389393',
    },
    naver: {
      id: 's_49ccad7e4536',
    },
  },
};

const defaultConfig = {
  google: {
    id: 'UA-138245180-4',
    conversion: 'fake',
    optimize: 'OPT-KBCNQJS',
  },
  gtm: {
    id: 'GTM-NVR4XK',
  },
  facebook: {
    id: '1222424581214735',
  },
  kakao: {
    id: 'fake',
  },
  naver: {
    id: 'fake',
  },
  mobon: {
    id: 'fake',
  },
};

const selectedEvnConfig = envConfigs[process.env.NODE_ENV];

if (selectedEvnConfig) {
  const keys = Object.keys(defaultConfig);
  for (const key of keys) {
    if (selectedEvnConfig[key]) {
      defaultConfig[key] = { ...defaultConfig[key], ...selectedEvnConfig[key] };
    }
  }
}

export default defaultConfig;
